import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaoutstationpune() {



  const cardData =
  {
    keyword: 'Innova Crysta Outstation Pune',
    heading: 'Sai Trupti Cabs: Innova Crysta Outstation Pune',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Innova Crysta out-station cab services in Pune, designed to make your longer inter-city or out-station journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Toyota Innova Crysta vehicles — all equipped with clean interiors, spacious 6+1 or 7+1 seating, and ample luggage space for families, groups and out-station travel. Every trip is driven by a professional, background-verified chauffeur who ensures punctual pickup anywhere in Pune, courteous service, and safe, smooth driving throughout your journey. With transparent per-km or day-package fares, flexible booking options (one-way or round-trip), and 24 × 7 customer support, Sai Trupti Cabs makes your Innova Crysta hire from Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Innova Crysta Outstation Pune",
      "description": "Rent an Innova Crysta in Pune for outstation trips with spacious seating for 7, AC/non-AC options, professional drivers, luggage support, flexible schedules, and transparent fares. Ideal for family getaways and long-distance travel."
    },
    {
      "name": "Pune Innova Crysta Hire",
      "description": "Reliable Innova Crysta rental in Pune offering well-maintained vehicles, AC/non-AC options, professional drivers, luggage assistance, and affordable pricing for comfortable local and outstation trips."
    },
    {
      "name": "AC Innova Crysta on Rent Pune",
      "description": "Premium AC Innova Crysta rental in Pune providing a cool and comfortable ride with professional drivers, luggage support, flexible pickup/drop points, online booking, and transparent fares for families and corporate travelers."
    },
    {
      "name": "Non AC Innova Crysta Hire Pune",
      "description": "Budget-friendly non-AC Innova Crysta rental in Pune with professional drivers, luggage assistance, flexible pickup/drop points, and transparent fares for local, one-way, and outstation travel."
    },
    {
      "name": "Luxury Innova Crysta Pune",
      "description": "Experience luxury travel with Innova Crysta rental in Pune offering premium interiors, AC service, professional drivers, luggage support, and punctual pickups. Perfect for weddings, corporate events, and VIP trips."
    },
    {
      "name": "Innova Crysta for Corporate Trips Pune",
      "description": "Corporate Innova Crysta hire in Pune providing AC/non-AC vehicles, professional chauffeurs, luggage assistance, flexible pickup/drop schedules, online booking, and transparent fares for business travel."
    },
    {
      "name": "Innova Crysta for Wedding Pune",
      "description": "Innova Crysta rental in Pune for weddings ensuring luxury, comfort, AC/non-AC options, professional drivers, luggage support, and timely pickups for smooth wedding transportation."
    },
    {
      "name": "Pune Innova Crysta Drop",
      "description": "Outstation or local Innova Crysta drop service in Pune with AC/non-AC options, professional drivers, luggage assistance, flexible schedules, online booking, and transparent fares for safe and comfortable travel."
    },
    {
      "name": "Outstation Innova Crysta Booking Pune",
      "description": "Book an Innova Crysta in Pune for outstation trips with AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, online booking, and transparent fares for hassle-free long-distance travel."
    },
    {
      "name": "Affordable Innova Crysta Pune",
      "description": "Budget-friendly Innova Crysta rental in Pune offering AC/non-AC options, professional drivers, luggage assistance, flexible schedules, and transparent fares for local, one-way, and outstation travel."
    },
    {
      "name": "Innova Crysta Online Booking Pune",
      "description": "Book your Innova Crysta online in Pune instantly with secure payments, AC/non-AC vehicles, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for convenient travel."
    },
    {
      "name": "Innova Crysta Hire Near Me Pune",
      "description": "Find Innova Crysta rental near your location in Pune for quick and convenient booking. Includes AC/non-AC options, professional drivers, luggage assistance, flexible schedules, and affordable fares."
    },
    {
      "name": "Innova Crysta Family Trip Pune",
      "description": "Rent an Innova Crysta in Pune for family trips with spacious seating for 7, AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for safe and comfortable travel."
    },
    {
      "name": "Best Innova Crysta Rental Pune",
      "description": "Top-rated Innova Crysta rental in Pune providing well-maintained vehicles, AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, and reliable service for local and outstation travel."
    },
    {
      "name": "Pune Innova Crysta 7-Seater Hire",
      "description": "Hire a 7-seater Innova Crysta in Pune for group travel with AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for comfortable and safe rides."
    }
  ],
  "tableData": [
    ["Innova Crysta Outstation Pune", "Pune Innova Crysta Hire"],
    ["AC Innova Crysta on Rent Pune", "Non AC Innova Crysta Hire Pune"],
    ["Luxury Innova Crysta Pune", "Innova Crysta for Corporate Trips Pune"],
    ["Innova Crysta for Wedding Pune", "Pune Innova Crysta Drop"],
    ["Outstation Innova Crysta Booking Pune", "Affordable Innova Crysta Pune"],
    ["Innova Crysta Online Booking Pune", "Innova Crysta Hire Near Me Pune"],
    ["Innova Crysta Family Trip Pune", "Best Innova Crysta Rental Pune"],
    ["Pune Innova Crysta 7-Seater Hire", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Outstation from Pune",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers premium and spacious Toyota Innova Crysta for outstation journeys starting from Pune—ideal for family trips, group outings, or corporate travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our outstation packages for the Innova Crysta generally start from around **₹5,700/day** for a minimum of ~300 km, with extra‑km charged at about **₹19‑₹20/km**. :contentReference[oaicite:turn0search0]{index=1}"
  },
  {
    "WhyChooseheading": "Flexible Durations & Distance Coverage",
    "WhyChoosedescription": "Typical outstation usage includes 12 hours or ~300 km/day; additional km or hours are billed as per terms—ensuring clarity before you embark. :contentReference[oaicite:turn0search5]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "While the Innova Crysta is our top‑choice, we also offer hatchbacks, sedans, SUVs and other premium vehicles to match your travel group size, luggage and comfort needs."
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous and professional drivers are familiar with long‑distance outstation routes, ensure timely starts and reliable travel — giving you peace of mind."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "Each Innova Crysta is regularly serviced, sanitized and equipped for comfort and safety—ideal for a longer journey away from home."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, itinerary changes, route planning or any assistance required during your outstation trip."
  },
  {
    "WhyChooseheading": "Easy & Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Innova Crysta outstation ride from Pune easily via call, WhatsApp or our website — receive quick confirmation and prompt vehicle dispatch."
  }
]

















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs Pvt Ltd offer Innova Crysta on rent for outstation trips from Pune?',
    answer: 'Yes, Sai Trupti Cabs Pvt Ltd provides reliable and comfortable Innova Crysta cab services for outstation trips starting from Pune, ideal for family, group, corporate or leisure travel.',
  },
  {
    question: 'How can I book an Innova Crysta for an outstation trip from Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your Innova Crysta outstation trip from Pune through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What are the features and seating capacity of the Innova Crysta outstation fleet?',
    answer: 'Our Innova Crysta cabs offer 6+1 or 7+1 seating, spacious luggage space, premium interiors, air‑conditioning, and are well suited for longer outstation journeys from Pune.',
  },
  {
    question: 'Are the drivers experienced for Innova Crysta outstation trips from Pune?',
    answer: 'Yes, all our drivers for outstation services are professional, courteous, and experienced in long‑distance routes, ensuring a safe and comfortable journey from Pune.',
  },
  {
    question: 'Is the Innova Crysta outstation service from Pune available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 availability for Innova Crysta outstation bookings from Pune, providing flexibility for pickup time and travel schedule.',
  },
  {
    question: 'What are the typical fare estimates for booking an Innova Crysta for outstation trips from Pune?',
    answer: 'Outstation fare estimates for Innova Crysta from Pune start at around **₹ 16‑₹ 20 per km** for long‑day packages (depending on route, duration, minimum kms/day), with typical daily minimums of 250‑300 kms and driver allowance applicable. :contentReference[oaicite:1]{index=1}',
  },
  {
    question: 'What payment methods are accepted for outstation Innova Crysta bookings from Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle‑free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Innova Crysta outstation trips from Pune?',
    answer: 'All Innova Crysta vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Innova Crysta outstation journey from Pune?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you throughout your Innova Crysta outstation trip starting from Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'Booking an Innova Crysta for our outstation trip from Pune with Sai Trupti Cabs was seamless. The vehicle was clean and the driver extremely professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshmukh',
    feedback: 'Sai Trupti Cabs provided excellent Innova Crysta service for our Pune‑outstation journey. Very smooth ride, comfortable vehicle, and courteous driver.',
    rating: 5,
  },
];


















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Outstation Pune",
  "image": "https://saitrupticabs.com/assets/images/innova-crysta-pune.jpg",
  "description": "Hire an Innova Crysta in Pune for outstation trips with Sai Trupti Cabs. Available for AC or Non-AC, corporate trips, weddings, family trips, and drop services. Book online at affordable rates for a comfortable 7-seater ride.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11234"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/innova-crysta-outstation-pune"
  }
};





  return (
    <div>
      <Helmet>
  <title>Innova Crysta Outstation Pune | AC & Non-AC | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Hire an Innova Crysta in Pune for outstation trips with Sai Trupti Cabs. Available for AC or Non-AC, corporate trips, weddings, family trips, and drop services. Book online at affordable rates for a comfortable 7-seater ride." 
  />
  <meta 
    name="keywords" 
    content="Innova Crysta Outstation Pune, Pune Innova Crysta Hire, AC Innova Crysta on Rent Pune, Non AC Innova Crysta Hire Pune, Luxury Innova Crysta Pune, Innova Crysta for Corporate Trips Pune, Innova Crysta for Wedding Pune, Pune Innova Crysta Drop, Outstation Innova Crysta Booking Pune, Affordable Innova Crysta Pune, Innova Crysta Online Booking Pune, Innova Crysta Hire Near Me Pune, Innova Crysta Family Trip Pune, Best Innova Crysta Rental Pune, Pune Innova Crysta 7-Seater Hire" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaoutstationpune;